// @ts-check
import { z } from 'zod';

/**
 * Specify your client-side environment variables schema here.
 * This way you can ensure the app isn't built with invalid env vars.
 * To expose them to the client, prefix them with `VITE_`.
 */
export const clientSchema = z.object({
  VITE_APP_ENV: z
    .enum(['development', 'production', 'preview', 'staging'])
    .optional()
    .default('development'),
  VITE_AUTHENTICATION_URL: z.string(),

  VITE_EWA_PAYLEO_BASE_URL: z.url(),
  VITE_IDENTITYKIT_PAYLEO_BASE_URL: z.url(),

  VITE_FIREBASE_AUTH_EMULATOR_HOST: z.string().optional(),

  VITE_SENTRY_DSN: z.url(),

  // PostHog environment variables
  VITE_POSTHOG_API_KEY: z.string(),
  VITE_POSTHOG_API_HOST: z.url(),
});

/**
 * You can't destruct `process.env` as a regular object, so you have to do
 * it manually here. This is because Next.js evaluates this at build time,
 * and only used environment variables are included in the build.
 * @type {{ [k in keyof z.input<typeof clientSchema>]: string | undefined }}
 */
export const clientEnv = {
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_AUTHENTICATION_URL: import.meta.env.VITE_AUTHENTICATION_URL,

  VITE_EWA_PAYLEO_BASE_URL: import.meta.env.VITE_EWA_PAYLEO_BASE_URL,
  VITE_IDENTITYKIT_PAYLEO_BASE_URL: import.meta.env.VITE_IDENTITYKIT_PAYLEO_BASE_URL,

  // only used when there's local
  VITE_FIREBASE_AUTH_EMULATOR_HOST: import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST,

  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,

  // PostHog environment variables
  VITE_POSTHOG_API_KEY: import.meta.env.VITE_POSTHOG_API_KEY,
  VITE_POSTHOG_API_HOST: import.meta.env.VITE_POSTHOG_API_HOST,
};
